<template>
  <section
    class="Modal ModalZoom"
    @click.self="closeModal"
    v-if="showModal"
    :class="{ display: showModal }"
  >
    <div class="Modal-inner">
      <div class="Modal-header">
        <h2>{{ productName }}</h2>
        <div class="Modal-close" @click="closeModal">
          <svg v-svg symbol="Close" size="0 0 16 16" role="presentation" class="icon--inline"></svg>
        </div>
      </div>
      <div class="Modal-row">
        <div class="Modal-content">
          <div class="ModalZoom-zoom" v-if="showZoom">
            <!-- Slider For -->

            <zoom-on-hover
              :scale="3"
              :img-normal="currentImageSrc"
              v-if="currentImageSrc"
            ></zoom-on-hover>
          </div>
          <div class="ModalZoom-zoom ModalZoom-zoomVideo" v-else style="width: 100%">
            <!-- Slider For -->

            <iframe
              frameborder="0"
              :src="currentVideoUrl"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
          <div class="ModalZoom-trigger">
            <!-- Slider Nav -->
            <VueSlickCarousel
            v-if="gallery.length > 1 || productVideos.length > 0"
            class="ProductGallery-sliderNav" v-bind="settingsFor">
              <img
                class="ProductGallery-itemNav lazyload"
                @click="slideNav"
                :data-src="gallery[0]"
              />
              <div
                class="ProductGallery-itemContainer"
                v-for="(imageVideo, index) in productVideos"
                :key="'video' + index"
                @click="showIframe"
              >
                <img
                  :data-src="imageVideo | formatVideoThumbnail"
                  :data-url="imageVideo | formatVideoUrl"
                  class="ProductGallery-itemNav Video lazyload"
                />
                <svg
                  v-svg
                  symbol="Play"
                  size="0 0 30 30"
                  role="presentation"
                  class="icon--inline"
                ></svg>
              </div>
              <img
                v-for="(image, index) in gallery.filter((image, key) => key > 0)"
                class="ProductGallery-itemNav lazyload"
                @click="slideNav"
                :data-src="image"
                :key="'image' + index"
              />
            </VueSlickCarousel>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import "@/components/Modal/Modal.scss";
import VueSlickCarousel from "vue-slick-carousel";
import { mapGetters } from "vuex";

export default {
  name: "Modal",
  components: {
    VueSlickCarousel,
  },

  data () {
    return {
      slidesToShowNav: 0,
      currentImageSrc: "",
      currentVideoUrl: "",
      showZoom: true,
      settingsFor: {
        arrows: true,
        speed: 500,
        slidesToShow: 6,
        focusOnSelect: true,
        slidesToScroll: 1,
      },
    };
  },

  props: {
    showModal: Boolean,
    imageSrc: String,
    gallery: Array,
  },

  computed: {
    ...mapGetters({ productName: "getProductName" }),
    ...mapGetters({ productVideos: "getProductVideos" }),
  },

  mounted () {
    this.currentImageSrc = this.imageSrc;
  },

  methods: {
    slideNav (event) {
      this.showZoom = true;
      this.currentImageSrc = event.target.getAttribute("src");
    },
    closeModal () {
      return this.$emit("Modal::close");
    },

    showIframe (event) {
      this.showZoom = false;
      this.currentVideoUrl = event.target.getAttribute("data-url");
    },
  },
};
</script>
